import { useState } from "react";

const useVideoHandlers = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isVideo, setIsVideo] = useState(false);

  const handlePlayVideo = () => {
    setIsVideo(true);
    setIsPlaying(true);
  };

  const handlePlay = () => {
    setIsPlaying(true);
  };

  const handlePause = () => {
    setIsPlaying(false);
  };

  const handleSeek = () => {
    // Your seek handling logic if needed
  };

  const handleVideoEnded = () => {
    setIsPlaying(false);
    setIsVideo(false);
  };

  const handleCloseVideo = () => {
    setIsPlaying(false);
    setIsVideo(false);
  };

  return {
    isPlaying,
    isVideo,
    handlePlayVideo,
    handlePlay,
    handlePause,
    handleSeek,
    handleVideoEnded,
    handleCloseVideo,
  };
};

export default useVideoHandlers;
